import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import SvgIcon from '@/components/SvgIcon.vue'

// 示例：使用 require.context 自动导入 SVG 文件
const req = require.context('./assets/img/leftBar', false, /\.svg$/)
req.keys().forEach(req)

const app = createApp(App)

app.use(ElementPlus)
app.use(router)
app.component('SvgIcon', SvgIcon)
app.mount('#app')
